/**
 * A festival_areas.polygon, read as a GeoJSON Polygon geometry.
 *
 * One reader for every map (the producer web maps, the crew map and the
 * PROduce Producer app's map): the three used to carry identical copies.
 */

/** GeoJSON polygon stored as Json in festival_areas.polygon. */
export interface GeoJsonPolygon {
  type: string;
  coordinates: number[][][];
}

/**
 * The polygon geometry, or null when the value is not an object. Some rows
 * store a GeoJSON Feature instead of a bare Geometry; the Feature is
 * unwrapped. The coordinates are NOT validated here — see polygonValidity.
 */
export function parsePolygon(json: unknown): GeoJsonPolygon | null {
  if (!json || typeof json !== "object" || Array.isArray(json)) return null;
  const obj = json as Record<string, unknown>;
  // Handle Feature wrapping (some DB rows store Feature instead of Geometry)
  if (obj.type === "Feature" && obj.geometry && typeof obj.geometry === "object") {
    return obj.geometry as GeoJsonPolygon;
  }
  return obj as unknown as GeoJsonPolygon;
}
